import {Lang} from 'yougile-lang'
import {isUndefined, logger} from 'yougile-util'
import {UserEvent} from 'yougile-model'
import {TimetrackingCtl} from '@extensions/sticker/controllers/timetracking-ctl'

export const getActionNameChangeTimeTracking = (event: UserEvent): string => {
  if (event.type !== 'timetracking') {
    return ''
  }

  const {options} = event
  if (!options) {
    return ''
  }

  if (options?.oldValue && !options?.newValue) {
    return Lang.msg.statsTimeline.statActionDetachedTimetracker
  }

  const oldPlan = options?.oldValue?.plan
  const newPlan = options?.newValue?.plan
  const oldWork = options?.oldValue?.work
  const newWork = options?.newValue?.work

  if (!options?.oldValue && options?.newValue) {
    const plan = getTime(newPlan)
    const work = getTime(newWork)
    return Lang.msg.statsTimeline.statActionSetTimeTrackerSet(plan, work)
  }

  if (oldPlan !== newPlan && oldWork !== newWork) {
    const prevPlan = getTime(oldPlan)
    const currPlan = getTime(newPlan)
    const prevWork = getTime(oldWork)
    const currWork = getTime(newWork)

    return Lang.msg.statsTimeline.statActionSetTimeTrackerChange(
      prevPlan,
      currPlan,
      prevWork,
      currWork
    )
  }

  if (oldPlan !== newPlan) {
    if (isUndefined(oldPlan) && newPlan) {
      const str = getTime(newPlan)
      return Lang.msg.statsTimeline.statActionSetTimeTrackerSetPlan(str)
    }

    if (!isUndefined(oldPlan) && !isUndefined(newPlan)) {
      const prev = getTime(oldPlan)
      const curr = getTime(newPlan)
      return Lang.msg.statsTimeline.statActionSetTimeTrackerChangePlan(
        prev,
        curr
      )
    }
  }

  if (oldWork !== newWork) {
    if (isUndefined(oldWork) && newWork) {
      const str = getTime(newWork)
      return Lang.msg.statsTimeline.statActionSetTimeTrackerSetWork(str)
    }

    if (!isUndefined(oldWork) && !isUndefined(newWork)) {
      const prev = getTime(oldWork)
      const curr = getTime(newWork)
      return Lang.msg.statsTimeline.statActionSetTimeTrackerChangeWork(
        prev,
        curr
      )
    }
  }

  logger.warn('event', JSON.stringify(event, null, ' '))

  return 'Error'
}

const defaultValue = '00:00'
const getTime = (time: number): string => {
  return TimetrackingCtl.hhmm(time, defaultValue)
}
